<template>
    <div class="popUp-cont bg-white p-4 shadow-lg text-left">
        <h2 class="ml-2 fw-bolder">{{ t('safetyPrecautions') }}</h2>
        <div class="popup-content-wrapper">
            <ul class="popup-content">
                <li><strong>{{ t('healthFirst') }}</strong>: {{ t('healthFirstDesc') }}</li>
                <li><strong>{{ t('safeSetup') }}</strong>: {{ t('safeSetupDesc') }}</li>
                <li><strong>{{ t('stayHydrated') }}</strong>: {{ t('stayHydratedDesc') }}</li>
                <li><strong>{{ t('getHelp') }}</strong>: {{ t('getHelpDesc') }}</li>
            </ul>
        </div>
        <button class="popup-button" @click.prevent="$emit('hideModal')">{{ t('iAcknowledge') }}</button>
    </div>
</template>

<script>
import { i18nComponentMixin } from "@/i18n/mixin";
export default {
    mixins:[i18nComponentMixin('components/SafetyPopup')],
}

</script>

<style scoped lang="scss">
.popUp-cont{
    position: relative;
    border-radius: 20px;
    border-top: 40px solid #91C934;
    display: flex;
    flex-direction: column;
    button{
        width: 100%;
        bottom: 0;
        left: 0;
        border: none;
        outline: none;
        color: white;
        background-color: #91C934;
        position: absolute;

        
    }
    .popup-button {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        border: none;
        outline: none;
        color: white;
        background-color: #91C934;
        border-radius: 0 0 20px 20px;
        padding: 10px;
        &:hover{
                background-color: darken(#91C934, 2%);
                text-decoration: underline;
        }
    }
}

.popup-content-wrapper {
    flex: 1; 
    overflow-y: auto; 
    padding-bottom: 3rem;
}

.popup-content {
    list-style-position: inside;
    padding: 0;
    margin: 0;
}

@media screen and (min-height: 400px) and (orientation: landscape), 
       screen and (orientation: portrait) {
    .blur-cont{
        display: flex;
        justify-content: center;
    }
}

</style>